import React from 'react';
import { useI18n } from '../../hooks/useI18n';

interface NotificationItem {
  id: number;
  title: string;
  body: string;
  is_read: boolean;
  created_at: string;
}

interface NotificationDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  notifications: NotificationItem[];
  onMarkRead: (id: number) => void;
}

export const NotificationDrawer: React.FC<NotificationDrawerProps> = ({ isOpen, onClose, notifications, onMarkRead }) => {
  const { t } = useI18n();
  if (!isOpen) return null;

  return (
    <>
      <div className="cab-drawer-overlay" onClick={onClose} />
      <div className="cab-drawer">
        <div className="cab-drawer-header">
          <h3>{t('notifications') || 'Powiadomienia'}</h3>
          <button className="cab-drawer-close" onClick={onClose}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>
        <div className="cab-drawer-content">
          {notifications.length === 0 ? (
            <div className="cab-drawer-empty">
              {t('no_notifications') || 'Brak powiadomień'}
            </div>
          ) : (
            <ul className="cab-notifications-list">
              {notifications.map((notif) => (
                <li key={notif.id} className={`cab-notification-item ${!notif.is_read ? 'unread' : ''}`} onClick={() => {
                  if (!notif.is_read) onMarkRead(notif.id);
                }}>
                  <div className="cab-notif-title">{notif.title}</div>
                  <div className="cab-notif-body">{notif.body}</div>
                  <div className="cab-notif-date">{new Date(notif.created_at).toLocaleString()}</div>
                  {!notif.is_read && <div className="cab-notif-dot" />}
                </li>
              ))}
            </ul>
          )}
        </div>
        <style>{`
          .cab-drawer-overlay {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba(0,0,0,0.4);
            z-index: 1000;
          }
          .cab-drawer {
            position: fixed;
            top: 0;
            right: 0;
            width: 100%;
            max-width: 360px;
            height: 100vh;
            background: #fff;
            z-index: 1001;
            box-shadow: -4px 0 24px rgba(0,0,0,0.1);
            display: flex;
            flex-direction: column;
            animation: slideInRight 0.3s ease-out forwards;
          }
          @keyframes slideInRight {
            from { transform: translateX(100%); }
            to { transform: translateX(0); }
          }
          .cab-drawer-header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 20px 24px;
            border-bottom: 1px solid #f0f0f0;
          }
          .cab-drawer-header h3 {
            margin: 0;
            font-size: 18px;
            color: #080A29;
            font-weight: 700;
          }
          .cab-drawer-close {
            background: none;
            border: none;
            cursor: pointer;
            color: #9A89B4;
            padding: 4px;
            display: flex;
            align-items: center;
            justify-content: center;
            transition: color 0.2s;
          }
          .cab-drawer-close:hover {
            color: #361777;
          }
          .cab-drawer-content {
            flex: 1;
            overflow-y: auto;
            padding: 16px 0;
          }
          .cab-drawer-empty {
            padding: 32px 24px;
            text-align: center;
            color: #9A89B4;
            font-size: 14px;
          }
          .cab-notifications-list {
            list-style: none;
            margin: 0;
            padding: 0;
          }
          .cab-notification-item {
            padding: 16px 24px;
            border-bottom: 1px solid #f8f7fb;
            position: relative;
            cursor: pointer;
            transition: background 0.2s;
          }
          .cab-notification-item:hover {
            background: #f8f7fb;
          }
          .cab-notification-item.unread {
            background: #fdfcff;
          }
          .cab-notif-title {
            font-weight: 600;
            color: #080A29;
            font-size: 14px;
            margin-bottom: 4px;
            padding-right: 16px;
          }
          .cab-notif-body {
            color: #666;
            font-size: 13px;
            line-height: 1.4;
            margin-bottom: 8px;
          }
          .cab-notif-date {
            color: #9A89B4;
            font-size: 11px;
          }
          .cab-notif-dot {
            position: absolute;
            top: 20px;
            right: 24px;
            width: 8px;
            height: 8px;
            background: #E84545;
            border-radius: 50%;
          }
        `}</style>
      </div>
    </>
  );
};
